<template>
  <div>
    <a id="btn-languages" title="languages" class="app-functions" href="javascript:">
      <i class="far fa-globe"></i>
    </a>
    <b-popover
      custom-class="languages-container-popover"
      target="btn-languages"
      placement="bottom"
      triggers="hover"
    >
      <div class="list-group languages-container" v-for="(lang, index) in languages">
        <a
          href="#"
          :key="index"
          @click="onChangeLanguage(lang.id)"
          :class="{'active': langCurrent(lang.id)}"
          class="list-group-item list-group-item-action"
        >
          <img height="20px" width="28px" :src="lang.img" :alt="lang.alt">
          {{ lang.label }}
        </a>
      </div>
    </b-popover>
  </div>
</template>

<script>
import numeral from 'numeral';

export default {
  name: 'AppLanguageSwitcher',
  data() {
    return {
      languages: [
        { id: 'vi', label: 'Tiếng Việt', img: '/images/flag-VN.png', alt: 'Flag Viet Nam' },
        { id: 'en', label: 'English', img: '/images/flag-UK.png', alt: 'Flag United Kingdom' },
      ],
    };
  },
  methods: {
    langCurrent(lang) {
      return this.$i18n.locale === lang;
    },
    onChangeLanguage(newLang) {
      this.$i18n.locale = newLang;
      localStorage.setItem('lang', this.$i18n.locale);
      window.location.reload();
      numeral.locale(this.$i18n.locale);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/app-language-switcher/index.vue